import { defaultSection } from './default'
import { objToList } from './index'
import { getFormData } from './form'
import { getField } from './fields'
import { cloneDeep } from 'lodash';

const showLogisticsCategoryField = {
    "name": "showLogisticsCategory",
    "label": "物流件重尺",
    "type": "CHECKBOX",
    "rules": {
        // "required": "true"
    },
    "options": [
        {
            "displayName": "按规格设置",
            "value": "sku",
            "tipText": "推荐设置"
        },
        {
            "displayName": "按商品设置",
            "value": "item",
        }
    ],
}
const logisticsWeightTableField = {
    "name": "logisticsWeightTable",
    "label": "",
    "type": "COMPLEX",
    "rules": {},
}
const useGroupImagesField = {
    "name": "useGroupImages",
    "label": "引用套图",
    "type": "COMPLEX",
    "rules": {},
    isShowFn(alibabaForm) {
        return alibabaForm.showGroupImages === undefined ? true : alibabaForm.showGroupImages
    }
}



/**
 * 根据默认配置从接口数据捞出需要的数据(接口会返回所有数据)
 * @param {*} data 
 */
export const generateSections = (data = {}, options = {}) => {
    const schemaData = cloneDeep(data)
    if (Object.keys(schemaData).length <= 0) return
    // 物流件重尺
    schemaData['showLogisticsCategory'] = showLogisticsCategoryField
    schemaData['logisticsWeightTable'] = logisticsWeightTableField
    schemaData['useGroupImages'] = useGroupImagesField
    const formFields = objToList(schemaData)
    formFields.forEach(item => {
        if (item.name && /\./.test(item.name)) {
            // 对于name字段中含有.的进行替换为_____（5个下划线），不然在el-form-item中prop属性时会报错
            item.propName = item.name.replaceAll('.', '_____')
        }
    })

    // 按照默认配置获取数据
    const formSections = defaultSection.reduce((list, item) => {
        let fields = item.fieldsMatch.reduce((fields, { reg, props }) => {
            let list = []
            formFields.forEach(item2 => {
                if (reg.test(item2.name)) {
                    if (item2.name === "supplyType") {
                        item2.options = item2.options.map(op => {
                            const tipTexts = {
                                '1': '在库库存充足商品（48小时内发货享更多流量）',
                                '2': '支持商品快返生产、以及基于现款的属性定制，可按规格设置快返库存及交期',
                            };
                            return {
                                ...op,
                                tipText: tipTexts[op.value],
                                disabled: op.value == 1
                            }
                        })
                    } else if (item2.name === "onlineTrade") {
                        const notSupportItem = item2.options.find(op => op.displayName == '不支持')
                        if (notSupportItem) {
                            notSupportItem.disabled = true
                        }
                    }
                    item2 = { ...item2, ...props }
                    list.push(item2)
                }
            }) // 捞需要显示的数据
            let field = getField(list) // 生成 field
            return fields.concat(field)
        }, [])

        return list.concat({
            title: item.title,
            children: fields
        })
    }, [])

    let formData = getFormData(formSections); // 生成 form 表单对象

    return { formData, formSections }
}
